import { useEffect, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import {
  closeDespiteMailSend,
  installMailSendLeave,
  mailSendLeavePromptOpen,
  subscribeMailSendLeave,
  waitForMailSend,
} from "@/lib/outbox/mailSendLeave";

export function MailSendLeaveDialog() {
  const open = useSyncExternalStore(subscribeMailSendLeave, mailSendLeavePromptOpen, () => false);

  useEffect(() => {
    installMailSendLeave();
  }, []);

  if (!open || typeof document === "undefined") return null;

  return createPortal(
    <div className="mail-send-hold" role="presentation" onClick={waitForMailSend}>
      <div
        className="mail-send-hold__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mail-send-hold-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="mail-send-hold-title">Un mail est en cours d’envoi</h2>
        <p>
          Si vous fermez Mail, l’envoi reprendra à la réouverture. Sinon, patientez : le serveur n’a pas encore le
          message.
        </p>
        <div className="mail-send-hold__actions">
          <button type="button" className="mail-send-hold__quiet" onClick={closeDespiteMailSend}>
            Fermer quand même
          </button>
          <button type="button" className="mail-send-hold__wait" onClick={waitForMailSend}>
            Patienter
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
